var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1OpacifyingFilterTurnOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 59V13H21v46h-6v4h46v-4h-6zm-30 0V17h11v42H25zm15 0V17h11v42H40z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Opacifying_filter_turn_on.9a22cf16.svg";
export { SvgC1OpacifyingFilterTurnOn as ReactComponent };